import { renderChip, renderDefaultChip } from "../../../chip/ChipRenderer.js";
import { ChipType, ChipVariant } from "../../../chip/types.js";
import "../../../chip/Chips.js";
import "../../../chip/ListWithChipTooltip.js";
import "../../../chip/SquaredChipList.js";
import "react";
import "@mui/material";
import "../../../icons/Icon.js";
import "../../../icons/ExpandMoreIcon.js";
const renderChipCell = (params) => {
  const { value, type } = params.value;
  return renderChip(value, type);
};
const renderDefaultChipCell = (params) => {
  const value = params.value;
  return renderDefaultChip(value, ChipVariant.Grey, ChipType.Status);
};
const renderColoredChipCell = (params) => {
  const { value, variant, type } = params.value;
  return renderDefaultChip(value, variant, type);
};
export {
  renderChipCell,
  renderColoredChipCell,
  renderDefaultChipCell
};
//# sourceMappingURL=ChipCell.js.map
